module.exports = __webpack_public_path__ + "img/kk.bf408857.png";